import React, { useState } from 'react';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

export const RadioButtonsGroup = props => {
    const { field, name, options } = props;
    const [ value, setValue ] = useState(props.value);

    const handleChange = (event) => {
        props.onChange(event)
        setValue(event.target.value);
    };

    return (
        <FormControl component="fieldset">
            <FormLabel component="legend">{field}</FormLabel>
            <RadioGroup row aria-label={name} name={name} value={value} onChange={handleChange}>
                {options.map((op, key) => 
                    <FormControlLabel key={key} value={op.value} control={<Radio color='primary' />} label={op.label} />
                )}
            </RadioGroup>
        </FormControl>
    );
}

export default RadioButtonsGroup;